import { useState, useEffect, useRef } from "react";
import { Typography, Box, InputBase, Tooltip, IconButton } from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import Detail from "../../main/detail/Detail";
import { rsActiveMenu, rsGotoLast, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseManageConsulators } from "./UseManageConsulators";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import CustomPagination from "../../components/CustomPagination";
import { deCapitalizeFirstLetter, toMoney } from "../../util/Utils";
import ProgressCom from "../../components/ProgressCom";
// import AssignmentAddIcon from "@mui/icons-material/AssignmentAdd";
import AssignmentIcon from "@mui/icons-material/Assignment";

export default function ManageConsulators(props) {
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC();
  let navigate = useNavigate();
  const location = useLocation();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { GetConsulators } = UseManageConsulators();
  const [consultantRes, setConsultantRes] = useState();
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    GetConsulators(
      myPc,
      search,
      (consultant) => {
        if (msGotoLast) {
          setMsGotoLast(false);
          goToLastPage(consultant.pageCondition.totalPage);
          return;
        }
        setConsultantRes(consultant);
      },
      true
    );
  }, [myPc]);

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const columns = [
    {
      field: "id",
      width: 70,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
      sortable: false,
      hide: true,
    },
    {
      field: "rowNO",
      width: 70,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
    },
    {
      field: "userID",
      width: 70,
      align: "center",
      headerName: "شناسه کاربر",
      headerAlign: "center",
      hide: true,
    },

    {
      field: "firstName",
      headerName: "نام",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.firstName}
          </Typography>
        );
      },
    },
    {
      field: "lastName",
      headerName: "نام خانوادگی",
      width: 150,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.lastName}
          </Typography>
        );
      },
    },
    {
      field: "mobile",
      headerName: "شماره موبایل",
      width: 130,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "allCount",
      headerName: "تعداد کل",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.allCount ? toMoney(cellValues.row.allCount) : 0}
          </Typography>
        );
      },
    },
    {
      field: "okCount",
      headerName: "انجام شده ها",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.okCount ? toMoney(cellValues.row.okCount) : 0}
          </Typography>
        );
      },
    },

    {
      field: "جزییات",
      sortable: false,
      width: 80,
      align: "center",
      headerAlign: "center",
      headerName: "جزییات",
      renderCell: (cellValues) => {
        return (
          <Tooltip title="add Client">
            <IconButton
              sx={{ ml: 1 }}
              onClick={() => {
                setScrollTo(cellValues.api.getScrollPosition());

                return navigate("/manageconsulators/consulatorDetail", {
                  state: {
                    model: cellValues.row,
                    myPc: myPc,
                    search: search,
                    id: cellValues.row.id,
                    userID: cellValues.row.userID,
                  },
                });
              }}
            >
              <AssignmentIcon fontSize="small" sx={{ color: "MyColor.main" }} />
            </IconButton>
          </Tooltip>
        );
      },
    },
    {
      field: "search",
      width: 210,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "ارتباط با مشتری",
        childs: [{ name: msActiveMenu.pageTitle, url: "/manageconsulators" }],
      }}
    >
      {consultantRes ? (
        <DataGrid
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={consultantRes.pageCondition.pageCount}
          rows={consultantRes.items}
          paginationMode="server"
          page={consultantRes.pageCondition.page - 1}
          onPageChange={(page) => {
            updatePage(page + 1);
          }}
          rowCount={consultantRes.pageCondition.totalItemCount}
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              scrollTo: myPc.scrollTo,
              isLtr: true,
              rowCount: consultantRes.pageCondition.totalItemCount,
              nofab: true,
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: deCapitalizeFirstLetter(myPc.sortColumn),
                  sort: deCapitalizeFirstLetter(myPc.sortOrder),
                },
              ],
            },
            pagination: {
              page: myPc.page,
            },
          }}
          onSortModelChange={(model) => {
            updateSort(model[0].field, model[0].sort == "asc" ? "asc" : "desc");
          }}
          sortingOrder={["desc", "asc"]}
          sortingMode="server"
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
